module.exports = __webpack_public_path__ + "img/carousel-photo04.f6b2853e.jpg";